"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewInstantaneousTelemetry extends new_item_1.default {
    constructor(newInstantaneousTelemetry) {
        super();
        this.value = newInstantaneousTelemetry.value;
        this.time = newInstantaneousTelemetry.time;
    }
}
exports.default = NewInstantaneousTelemetry;
//# sourceMappingURL=new-instantaneousTelemetry.js.map